import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const DeleteBankDetailsModal = ({ isOpen, onClose, onConfirm, bank }) => {
  const bodyMessage = `Are you sure you want to delete this bank detail? This action cannot be undone.`;

  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Confirm Delete"
      bodyMessage={<div dangerouslySetInnerHTML={{ __html: bodyMessage }} />}
      confirmLabel="Delete"
      cancelLabel="Cancel"
    />
  );
};

export default DeleteBankDetailsModal;
